export default "__VITE_ASSET__ce7f4fea__"